<faq>
  <script>
   import content from '../../../longform/faq.md';
   this.root.innerHTML = content;
  </script>
</faq>
